export default 
{
	"progressbar-page-title": "Page",
	"name-suffix": "Suffixe",
	"fileupload-desc-progress-message": "Téléchargement {progress}",
	"required-if-greater-than-or-equal": "{property} est requis lorsque {compareSource} est plus que ou égal à {compareValue}.",
	"powered-by-cognito": "Propulsé par Cognito Forms.",
	"form-name-default": "Sans titre",
	"field-choice-defaults": "Premier choix |Deuxième  choix |Troisième choix",
	"additional-fee-default-label": "Frais supplémentaires",
	"authenticated-save-and-resume-email-dialog": "Envoyer un lien par email et revenez à votre formulaire pour terminer votre soumission.",
	"string-length-between": "{property} doit être comprise entre {min} et {max} caractères.",
	"update-button-text": "Mettre à jour",
	"address-zip-code-invalid": "Zip Code doit être au format #####-####.",
	"required-if-greater-than": "{property} est requis lorsque {compareSource} est plus que{compareValue}.",
	"compare-before": "{property} doit être avant {compareSource}.",
	"compare-after": "{property} doit être après {compareSource}.",
	"unsupported-browser-message": "Oh non! Vous utilisez un navigateur non pris en charge. {a}Cliquez ici{/a} pour mettre à niveau.",
	"shared-entry-email-subject": "Lien Partagé",
	"send-button-text": "Envoyer",
	"venmo-help-text": "Connectez-vous à Venmo pour continuer le paiement.",
	"field-repeatingsection-item-label": "Article",
	"save-and-resume-email-not-sent-message": "Il y avait un problème.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} doit être au moins {min}.",
	"entry-notification-full-entry-detail-link": "Voir tous les détails au cognitoforms.com.",
	"element-label-website": "Site Web",
	"element-label-signature": "Signature",
	"paypal-help-text": "Connectez-vous à PayPal pour continuer le paiement.",
	"card-on-file-agreement-validation": "Vous devez accepter de sauvegarder votre carte pour les transactions futures.",
	"marketing-button-4": "Construisez Votre Propre Gratuitement",
	"field-datepicker-now": "Maintenant",
	"save-and-resume-email-resume-button": "Reprendre maintenant",
	"field-datepicker-next-month": "Mois suivant",
	"quantity-remaining-text": "restant",
	"payment-declined": "Paiement refusé",
	"required-if-before": "{property} est requis lorsque {compareSource} est avant {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} doit être moins que {compareSource}.",
	"entry-admin-link": "",
	"required-many": "{0} sont requis.",
	"save-and-resume-multiple-days-expiration-email-message": "Utilisez le lien ci-dessous pour retourner à votre formulaire et le compléter d\u0027ici les {days} prochains jours.",
	"string-length-at-least": "{property} doit être au moins {min} caractères.",
	"credit-card-number": "Numéro de carte de crédit",
	"range-on-or-before": "{property} doit être sur ou avant {max}.",
	"required-one": "{0} est requis.",
	"fileupload-max-file-count-exceeded-message": "Seuls {maxFileCount} fichiers peuvent être téléchargés.",
	"order-transaction-details-header": "Détails de la transaction",
	"field-spinner-increase": "Augmenter",
	"payment-processing-fees": "Frais de traitement",
	"payment": "Paiement",
	"field-choice-other-fill-in": "Autres",
	"shared-entry-email-message": "Une entrée a été partagé avec vous.",
	"shared-entry-workflow-link": "Voir le formulaire.",
	"required-if-exists": "{property} est requise lorsque {compareSource} est spécifié.",
	"concurrent-conflict-toast-message": "Votre envoi a échoué car les informations de ce formulaire ont changé. Vérifiez et réessayez.",
	"secured-by-paypal": "Sécurisé par",
	"range-on-or-after": "{property} doit être sur ou après {min}.",
	"payment-amount-due": "Montant dû",
	"required-name-first-and-last": "Prénom et Nom sont requis.",
	"required": "{property} est requis.",
	"string-format-alphabetic": "{property} doit uniquement contenir des lettres.",
	"quantity-limit": "{property} quantité dépassée.",
	"field-spinner-decrease": "Diminuer",
	"field-repeatingsection-add-link-text": "Ajouter",
	"fileupload-max-size-exceeded-message": "Seulement les fichiers moins que {maxSize} MB peuvent être téléchargés.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "Pas Capturé",
	"field-ratingscale-satisfied-unsatisfied-label": "Satisfait/Insatisfait",
	"range-between": "{property} doit se situer entre {min} et {max}.",
	"field-ratingscale-agree-disagree-label": "En accord/En désaccord",
	"back-button-text": "Précédent",
	"address-country": "Pays",
	"order-not-found": "Aucune information d\u0027ordre trouvée.",
	"field-ratingscale-satisfied-unsatisfied-options": "Très insatisfait|Insatisfait|Neutre|Satisfait|Très satisfait",
	"entry-notification-entry-details-header": "Détails de l\u0027entrée",
	"FALSE": "FAUX",
	"compare-greater-than-or-equal": "{property} doit être plus que ou égale à {compareSource}.",
	"receipt-notification-order-details-desc-header": "Description",
	"order-method-label": "Méthode",
	"order-total-label": "Total de la commande",
	"invalid-shared-link": "Lien Partagé Non Valide",
	"fileupload-zero-byte-file-message": "Fichiers de zéro octet ne peuvent pas être téléchargés.",
	"range-at-most": "{property} doit être au plus {max}.",
	"format-integer": "####",
	"order-date-label": "Date",
	"fileupload-dropzone-message": "ou faites glisser les fichiers ici.",
	"shared-entry-view-link": "Voir l\u0027entrée partagée.",
	"format-currency": "# ###,## €",
	"string-length-at-most": "{property} doit être au plus {max} caractères.",
	"entry-confirmation-footer-tagline": "Créez vos propres formulaires de paiement puissant avec",
	"submit-button-text": "Envoyer",
	"marketing-msg": "Créez facilement des formes puissantes.",
	"required-if-on-or-after": "{property} est requis lorsque {compareSource} doit être {compareValue} ou après. ",
	"card-on-file-agreement": "J\u0027accepte de sauvegarder ma carte pour les transactions futures.",
	"signature-draw": "dessiner",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} doit être sur ou après {compareSource}.",
	"required-if-less-than-or-equal": "{property} est requis lorsque {compareSource} est moins que ou égale à {compareValue}.",
	"field-datepicker-next-year": "Année suivante",
	"change-button": "changer",
	"fileupload-desc-size-in-bytes-message": "{size} octets",
	"card-tab": "Carte",
	"order-billing-info-header": "Informations de facturation",
	"entry-email-view-details-text": "Voir les détails de pleine entrée à cognitoforms.com.",
	"save-and-resume-one-day-expiration-email-message": "Utilisez le lien ci-dessous pour retourner à votre formulaire et le compléter d’ici un jour.",
	"credit-card-authentication-failed": "L\u0027authentification de la carte a échoué.",
	"compare-less-than-or-equal": "{property} doit être moins que ou égale à {compareSource}.",
	"receipt-notification-order-details-balance-due": "Solde dû",
	"save-and-resume-multiple-days-expiration-message": "Copiez ou envoyez le lien ci-dessous pour retourner à votre formulaire et le compléter d\u0027ici les {days} prochains jours.",
	"processing-fee-calculating-message": "Calcul",
	"receipt-notification-trx-details-method": "Méthode",
	"field-choice-no-match": "Aucune correspondance",
	"fileupload-invalid-file-type-message": "Seuls les fichiers {allowedTypes} peuvent être téléchargés.",
	"receipt-notification-trx-details-date": "Date",
	"credit-card-authorization": "Autorisation de carte",
	"address-line1": "Adresse ligne 1",
	"required-if-not-exists": "{property} est requis lorsque {compareSource} n\u0027est pas spécifié.",
	"required-if-not-equal": "{property} est requis lorsque {compareSource} n\u0027est pas {compareValue}.",
	"marketing-button-2": "Construisez Votre Propre Gratuitement",
	"receipt-notification-billing-info-header": "Informations de facturation",
	"required-if-after": "{property} est requis lorsque {compareSource} est après {compareValue}.",
	"element-label-name": "Nom",
	"required-if-equal": "{property} est requis lorsque {compareSource} est {compareValue}.",
	"connected-to-paypal": "Connecté à PayPal.",
	"people-form-email-quantity-exceeded-message": "L\u0027adresse email doit être unique.",
	"receipt-notification-order-details-subtotal": "Total partiel",
	"shared-entry-edit-link": "Modifiez l\u0027entrée partagée.",
	"receipt-notification-trx-details-header": "Détails de la transaction",
	"address-city": "Ville",
	"receipt-notification-order-details-amount-paid": "Montant payé",
	"credit-card-invalid": "Carte n\u0027est pas valide.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Vous avez un nouvel envoi de formulaire.",
	"this-and-that": "{0} et {1}",
	"field-ratingscale-good-poor-label": "Bon/Mauvaise",
	"network-unavailable-message": "Réseau indisponible, veuillez réessayer plus tard.",
	"dialog-close": "Fermer",
	"string-format-alphanumeric": "{property} doit contenir uniquement lettres et numéros.",
	"credit-card": "Carte de crédit",
	"remove-item": "Retirer {item}",
	"receipt-notification-order-details-price-header": "Prix",
	"fileupload-upload-inprogress-message": "Le téléchargement de fichiers est en cours.",
	"public-terms-of-service-link-text": "Conditions d\u0027utilisation",
	"save-and-resume-email-subject": "Lien pour enregistrer et reprendre",
	"field-repeatingsection-remove-link-text": "Retirer",
	"field-ratingscale-na-label": "N/A",
	"add-item": "Ajouter {item}",
	"field-toggle-options": "Oui/Non|Vrai/Faux|Ouvert/Fermé|Actif/Inactif|Lu/Non lu",
	"order-submit-timeout": "Traitement des commandes prend trop de temps. S’il vous plaît essayer votre commande plus tard.",
	"listlength-at-most": "S\u0027il vous plaît ne pas spécifier plus de {max} {property}.",
	"shared-entry-email-view-message": "Utilisez le lien ci-dessous pour afficher l\u0027entrée partagée.",
	"order-number-label": "Nombre",
	"card-declined": "Carte refusée",
	"fileupload-default-upload-button-text": "Téléverser",
	"name-prefix": "Titre",
	"address-line2": "Adresse ligne 2",
	"element-label-email": "E-mail",
	"field-ratingscale-good-poor-options": "Très Mauvaise|Mauvaise|Moyenne|Bon|Très Bon",
	"next-button-text": "Suivant",
	"question": "Question",
	"address-postalcode": "Code Postal / Zip Code",
	"format-with-description": "{property} doit être au format {description}.",
	"field-datepicker-prev-month": "Mois précédent",
	"name": "Nom",
	"receipt-notification-order-details-total-footer": "Total",
	"confirmation-message": "Merci d\u0027avoir rempli le formulaire. Votre réponse a été enregistrée.",
	"shared-entry-email-edit-message": "Utilisez le lien ci-dessous pour modifier l\u0027entrée partagée.",
	"field-default-label": "Sans titre",
	"required-value": "{property} doit être {value}.",
	"name-middle": "Deuxième prénom",
	"fileupload-failed-upload-message": "{fileName} n\u0027a pas réussi à télécharger.",
	"shared-entry-email-button-label": "Voir l\u0027entrée",
	"field-datepicker-year": "",
	"element-label-phone": "Téléphone",
	"TRUE": "VRAI",
	"listlength-between": "S\u0027il vous plaît spécifier entre {min} et {max} {property}.",
	"marketing-button-1": "Essayez-le Maintenant",
	"entry-submission-error-heading": "Il ya eu une erreur lors du traitement cette entrée.",
	"order-not-found-message": "Aucune information d\u0027ordre trouvée.",
	"format-without-description": "{property} n\u0027est pas au bon format.",
	"name-last": "Nom",
	"field-ratingscale-one-five-label": "Échelle de 1 à 5",
	"listlength-at-least": "S\u0027il vous plaît spécifier au moins {min} {property}.",
	"united-states": "États-Unis",
	"field-signature-captured": "Capturé",
	"compare-on-or-before": "{property} doit être sur ou avant {compareSource}.",
	"order-balance-due-label": "Solde dû",
	"required-if-less-than": "{property} est requis lorsque {compareSource} est moins que {compareValue}.",
	"credit-card-postalcode": "Code Postal",
	"form-not-available-message": "Ce formulaire n\u0027est pas disponible actuellement.",
	"element-label-address": "Adresse",
	"receipt-notification-trx-details-number": "Nombre",
	"public-submission-warning": "Veuillez ne pas soumettre des mots de passe par Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Utilisez le lien ci-dessous pour retourner à votre formulaire et le compléter.",
	"fileupload-excluded-file-type-message": "Fichiers de ce type ne peuvent pas être téléchargés.",
	"payment-subtotal": "Total partiel",
	"collapse": "Réduire",
	"save-button-text": "Enregistrer",
	"field-datepicker-prev-year": "Année précédente",
	"signature-type": "taper",
	"order-amount-minimum": "Montant dû doit être au moins de 1,00 €.",
	"string-format-numeric": "{property} doit contenir uniquement les numéros.",
	"entry-confirmation-entry-details-header": "Détails de l\u0027entrée",
	"connected-to-venmo": "Connecté à Venmo.",
	"format-percentage": "#,## %",
	"receipt-notification-header": "Reçu",
	"clear": "Effacer",
	"today": "Aujourd\u0027hui",
	"required-name-last": "Nom est requis.",
	"marketing-button-3": "Essayez-le Maintenant",
	"expand": "Développer",
	"compare-greater-than": "{property} doit être plus que {compareSource}.",
	"field-ratingscale-will-wont-label": "Sera/Ne Sera Pas",
	"required-name-first": "Prénom est requis.",
	"save-and-resume-one-day-expiration-message": "Copiez ou envoyez le lien ci-dessous pour retourner à votre formulaire et le compléter d’ici un jour.",
	"required-asterisk": "requis",
	"credit-card-required": "Carte de crédit est nécessaire.",
	"address-state-province-region": "État / Province / Région",
	"save-and-resume-email-sent-message": "L\u0027email a été envoyé.",
	"workflow-action": "Action",
	"field-ratingscale-will-wont-options": "Certainement ne sera pas|Ne sera probablement pas|Pas sûr|Sera probablement|Sera certainement",
	"save-and-resume-email-label": "Envoyez-moi mon lien:",
	"field-ratingscale-agree-disagree-options": "Fortement en désaccord|En désaccord|Neutre|En accord|Fortement en accord",
	"order-exception-order-already-paid": "Cette commande a déjà été payée.",
	"fileupload-download-text": "Télécharger",
	"address-state": "État",
	"allowed-values": "{property} n\u0027est pas dans la liste des valeurs autorisées.",
	"shared-entry-workflow-email-button-label": "Ouvrir le formulaire",
	"compare-equal": "{property} doit être le même que {compareSource}.",
	"field-datepicker-clear": "Effacer",
	"name-first": "Prénom",
	"save-and-resume-message": "Vos réponses ont été sauvegardées",
	"save-and-resume-no-expiration-message": "Copiez ou envoyez le lien ci-dessous pour retourner à votre formulaire et le compléter.",
	"entry-notification-view-details-text": "Voir les détails",
	"order-exception-default-message": "Impossible de traiter la transaction.",
	"public-report-abuse-link-text": "Signaler un abus",
	"order-amount-paid": "Montant payé",
	"element-label-default": "Sans titre",
	"countries": "Afghanistan|Afrique du Sud|Albanie|Algérie|Allemagne|Andorre|Angola|Anguilla|Antigua et Barbuda|Antilles néerlandaises|Arabie Saoudite|Argentine|Arménie|Aruba|Australie|Autriche|Azerbaïdjan|Bahamas|Bahreïn|Bangladesh|Barbade|Belgique|Belize|Bénin|Bermudes|Bhoutan|Biélorussie|Bolivie|Bosnie-Herzégovine|Botswana|Brésil|Brunei Darussalam|Bulgarie|Burkina Faso|Burundi|Cambodge|Cameroun|Canada|Cap-Vert|Chili|Chine|Chypre|Cité du Vatican (Saint-Siège)|Cocos (Keeling) Islands|Colombie|Comores|Congo, République of(Brazzaville)|Corée, populaire démocratique \u0027 s Rep (Corée du Nord)|Corée, République de (Corée du Sud)|Costa Rica|Côte d\u0027Ivoire|Croatie (Hrvatska)|Cuba|Curaçao|Danemark|Djibouti|Dominique|Égypte|Émirats Arabes Unis|Équateur|Espagne|Estonie|États-Unis|Éthiopie|Fédération de Russie|Féroé (îles)|Fidji|Finlande|France|Gabon|Gambie|Géorgie|Ghana|Gibraltar|Grèce|Grenade|Groenland|Guadeloupe|Guam|Guatemala|Guinée|Guinée-Bissau|Guyane|Haïti|Honduras|Hong Kong|Hongrie|Île Christmas|Ile de la réunion|Île de Man|Îles Caïmans|Îles Cook|Îles Falkland|Îles Mariannes du Nord|Îles Marshall|Îles Salomon|Îles Turques et Caïques|Îles Vierges (britanniques)|Inde|Indonésie|Irak|Iran (République islamique de)|Irlande|Islande|Israël|Italie|Jamaïque|Japon|Jordanie|Kazakhstan|Kenya|Kirghizistan|Kiribati|Kosovo|Koweït|La Grande-Bretagne|La Guinée équatoriale|L\u0027Antarctique|Lao, peuple \u0027 s République démocratique|L\u0027Érythrée|Lesotho|Lettonie|Liban|Libéria|Libye|Liechtenstein|L\u0027île de Pitcairn|Lituanie|Luxembourg|Macao|République de Macédoine du Nord|Madagascar|Malaisie|Malawi|Maldives|Mali|Malte|Maroc|Martinique|Maurice|Mauritanie|Mayotte|Mexique|Micronésie, États fédérés de|Moldova, République de|Monaco|Mongolie|Monténégro|Montserrat|Mozambique|Myanmar, Birmanie|Namibie|Nauru|Népal|Nicaragua|Niger|Nigeria|Niue|Norvège|Nouvelle Calédonie|Nouvelle-Zélande|Oman|Ouganda|Ouzbékistan|Pakistan|Palau|Panama|Papouasie Nouvelle-Guinée|Paraguay|Pays-Bas|Pérou|Philippines|Pologne|Polynésie Français|Porto Rico|Portugal|Qatar|République dominicaine|République tchèque|République centrafricaine|République démocratique du Congo (Kinshasa)|Roumanie|Royaume-Uni|Rwanda|Sahara occidental|Saint Vincent et les Grenadines|Sainte-Lucie|Saint-Kitts-et-Nevis|Saint-Marin|Saint-siège|Salvador|Samoa|Samoa américaines|Sao Tomé et Principe|Sénégal|Serbie|Seychelles|Sierra Leone|Singapour|Slovaquie (République slovaque)|Slovénie|Somalie|Soudan|Sri Lanka|Sud-Soudan|Suède|Suisse|Suriname|Swaziland|Syrie, République arabe syrienne|Tadjikistan|Taiwan (République de Chine)|Tanzanie ; officiellement la République-Unie de Tanzanie|Tchad|Territoires méridionaux Français|Territoires palestiniens|Thaïlande|Tibet|Timor oriental (Timor-Leste)|Timor-Leste (Timor oriental)|Togo|Tokélaou|Tonga|Trinité-et-Tobago|Tunisie|Turkménistan|Turquie|Tuvalu|Ukraine|Uruguay|Vanuatu|Venezuela|Vietnam|Virgin Islands (U.S.)|Wallis et Futuna|Yémen|Zambie|Zimbabwe",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Ordre doit contenir au moins un élément de ligne.",
	"compare-not-equal": "{property} doit être différent de {compareSource}.",
	"entry-notification-footer": "Vous recevez cet e-mail parce que vous avez sélectionné l\u0027option recevoir de notifications par courriel sur votre formulaire dans Cognito Forms.",
	"save-and-resume-copy-link-label": "Copiez le lien vers votre formulaire:",
	"entry-confirmation-footer": "Vous recevez cet e-mail parce que vous avez terminé une transaction avec [Name].",
	"required-if-on-or-before": "{property} est requis lorsque {compareSource} doit être {compareValue} ou plus tard.",
	"string-format": "{property} doit être au format {formatDescription}.",
	"switch-to-drawing-mode": "Passer en mode dessin depuis le mode saisie.",
	"switch-to-typing-mode": "Passer en mode saisie depuis le mode dessin.",
	"signature-present": "La signature est présente",
	"signature-drawing-area": "Zone de dessin de signature"
};
